// @flow
import { resolve } from 'redux-optimist-promise';
import { get } from 'lodash';
import {
  FETCH_PROPOSALS_BY_ID,
  FETCH_SELECTED_PROPOSAL_PAYMENT,
} from 'Store/booking/proposals/constants';

type State = Array<PaymentProvider>;

const initialState: State = [];

function paymentProvidersReducer(state: State = initialState, action: ?Action<*>): State {
  switch (get(action, 'type')) {
    case resolve(FETCH_PROPOSALS_BY_ID):
    case resolve(FETCH_SELECTED_PROPOSAL_PAYMENT):
      return get(action, 'payload.paymentProviders', initialState);

    default:
      return state;
  }
}

export default paymentProvidersReducer;
